import React, { Component } from "react";
import { NavLink, Link } from "react-router-dom";
import logodashheader from "../Assets/logo-dash-header.png";
import FeedBackImg from "../Assets/ratings-review.png";
import Footer from "../Components/footer";
import Header from "../Components/header";
import SideBar from "../Components/sidebar";
import Button from "../Components/button";
import DataTable from "../Components/datatablereview";
import {
  DateTime,
  RedirectNotLogin,
  RedirectContractor,
  getSession,
  UpdateState,
  getState,
  handleSubmit,
  BreedForm,
  AlertMessage,
  AlertMessageOut,
  serializeArray,
} from "../Components/function";

class MyCommit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userID: "",
      scriptID: "",
      file: "",
      message: "",
    };
  }

  componentDidMount() {
    RedirectNotLogin();
    RedirectContractor();
  }

  componentDidUpdate() {
    RedirectNotLogin();
    RedirectContractor();
  }

  render() {
    return (
      <div className="App AppWrap">
        <Header self={this} />

        <div className="App iBG dash-dash-full">
          <div className="containers">
            <div className="card-lt-wrap">
              <div className="card-lt breadcrumb view-editor-wrap">
                <div>
                  <h1>
                    <NavLink to="/dashboard">Dashboard</NavLink>{" "}
                    <i className="fa fa-chevron-right"></i>{" "}
                    <NavLink to="/my-commit">My Commit</NavLink>{" "}
                    <i className="fa fa-chevron-right"></i>{" "}
                    {getSession("division")}
                  </h1>
                </div>
                <div>
                  <NavLink to="/review">
                    <button
                      className="btn chip primaryX white"
                      style={{ fontSize: "14px" }}
                    >
                      {" "}
                      Peer Review <i className="fa fa-chevron-right"></i>
                    </button>
                  </NavLink>
                </div>
              </div>
            </div>

            <div className="card-lt-wrap">
              <div className="card-lt">
                {AlertMessageOut(this)}

                <DataTable
                  route="review"
                  badge={["", "", "", "", "", "", ""]}
                  thclassX={[
                    "",
                    "",
                    "center",
                    "",
                    "nowrap",
                    "nowrap",
                    "nowrap",
                    "",
                  ]}
                  th={[
                    "Script ID",
                    "Geo Target",
                    "Open Status",
                    "Summary",
                    "Review 1",
                    "Review 2",
                    "Review 3",
                    "Note",
                  ]}
                  td={[
                    "scriptID",
                    "target",
                    "commit_status",
                    "summary",
                    "cmd1",
                    "cmd2",
                    "cmd3",
                    "note",
                  ]}
                  cmd="review"
                  commit={1}
                  self={this}
                />
              </div>

              <Footer classX="dash-footer" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default MyCommit;
